// Topics published by sgwt-connect
export const BUS_ACCESS_TOKEN = 'sg-connect.access-token';
export const BUS_USER_CONNECTION = 'sg-connect.user-connection';

// Payload type for BUS_USER_CONNECTION topic
export interface ISgwtUserConnectionStatus {
  connected: boolean;
  mail?: string;
  claims?: any;
}


// Global topics
// Topic published by sgwt-super-header
export const BUS_GLOBAL_LANGUAGE = 'global.language';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/common/bus-topics.ts